export default "__VITE_ASSET__ChlwXLqq__"